$(function(){

  // スムーズスクロール
  $('a[href^="#"]').click(function() {
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
  });

  //fv 自動スライダー
  if ($('#fv_slide').length) {
    const swiper = new Swiper("#fv_slide", {
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 25,
      speed: 5000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.7,
        }
      }
    });
  }

  // fv下 ナビゲーションスライド
  if ($('#nav_slide').length) {
    const swiper = new Swiper("#nav_slide", {
      loop: true,
      autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
},

      slidesPerView: 1.5,
      spaceBetween: 20,
      centeredSlides: true, 
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 50
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }

  
  // 商品カテゴリー slide
  if ($('#category_slide').length) {
    const swiper = new Swiper("#category_slide", {
      slidesPerView: 1.5,
      spaceBetween: 30,
      breakpoints: {
        768: {
          slidesPerView: 2.7,
          spaceBetween: 50
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }



//select box(Amazone Pay)
  $('#ap_select_box select').change(function () {
    let val = $("[name=ap_hidden]").val();
    if (val == 'hide_ap') {
      $(".notice_amazone").hide();
    }
    else if (val == 'show_ap') {
      $(".notice_amazone").show();
    }
});

  //商品モーダル
    if ($('.item_detail_container').length) {
    const trigger = $('.modal_trigger'),
      wrapper = $('.modal_wrapper'),
      layer = $('.modal_layer'),
      container = $('.modal_container'),
      close = $('.modal_close');

    // 『モーダルを開くボタン』をクリックしたら、『モーダル本体』を表示
    $(trigger).click(function () {
      const target = $(this).data('target');
      $(target).fadeIn(400);

      // スクロール位置を戻す
      $(container).scrollTop(0);

      // サイトのスクロールを禁止にする
      $('html, body').css('overflow', 'hidden');
    });

    // 『背景』と『モーダルを閉じるボタン』をクリックしたら、『モーダル本体』を非表示
    $(layer).add(close).click(function () {
      $(wrapper).fadeOut(400);

      // サイトのスクロール禁止を解除する
      $('html, body').removeAttr('style');
    });
  }

  
  
});
